<template>
  <div class="p-2 bg-gray-200 dark:bg-gray-900">
    <orderDetail
      :rowId="selected.id"
      :isEvacuationEnd="selected.isEvacuationEnd"
      @isNewOrder="(val) => (isNewOrder = val)"
      @refresh="addrefresh()"
      ref="orderDetail"
      @orderList="(val) => (orderList = val)"
      @isLaterAddOrder="(val) => (isLaterAddOrder = val)"
    />
    <noteDetail :note="note" />
  
  <notesModal
         :type="'depo'"
         :orderStatus="'Depo Siparişi'"
         :evacuationId="selected?.id"
        />

    <addModal
      :isNewOrder="isNewOrder"
      :orderCount="selected.planCount"
      @refresh="addrefresh()"
      :isLaterAddOrder="isLaterAddOrder"
    />

    <updateEvacuationModal
      :orderNo="selected.orderNo"
      :rowId="selected.id"
      :orderItem="selected"
      @refresh="addrefresh()"
    />

    <vehicleModalVue
      :listType="`storage`"
      @refresh="getAll()"
      :rowId="selected.id"
      :orderNo="selected.orderNo"
      :order="orderList && orderList.length > 0 ? orderList[0] : {}"
      :isDisabled="selected.tonnage && selected.receivedTonnage ? selected.tonnage <= selected.receivedTonnage : false"
      :isOrderStopped="selected.evacuationState == 1"
      :isManualMode="selected.manualAssignmentMode == 1"
    />
    <div class="w-full">
      <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
        <div class="w-full">
          <LyrausTable
            :data="List"
            :columns="columns"
            :enablePagination="true"
            :isLoading="load"
            :batchOperations="!isArchived"
            :searchBar="true"
            :searchProp="search"
            @update-search-value="(val) => handleSearchValue(val)"
            :handleSearch="handleSearch"
            :alternateRowBg="['white', 'gray-100']"
            :pageCount="pageCount"
            :pageProp="currentPage"
            @update-current-page="handleCurrentPage"
            :totalCount="totalCount"
            :paginationButtonColor="'red-600'"
            :paginationHoverColor="'red-700'"
            :tdClass="'whitespace-nowrap border-gray-200 text-xs py-1'"
            :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
          >
            <template v-slot:searchBar> <SearchInput :value="search" :isFull="true" @searcing="(val) => {handleSearchValue(val); handleSearch();}" /> </template>
            <template v-slot:rowButtons="{ item, columnKey }">
              <button
                v-if="columnKey === 'manualAssignmentMode'"
                class="flex items-center justify-center border rounded-lg space-x-2 px-2 py-1 mx-2"
                :class="
                  item.manualAssignmentMode == 1
                    ? 'bg-green-100'
                    : 'bg-gray-100'
                "
                @click="toggleManualMode(item)"
                :disabled="true"
                :title="'Manuel Atama Modu aktif olarak ayarlanmış, değiştirilemiyor'"
              >
                <span
                  :class="
                    item.manualAssignmentMode == 1
                      ? 'text-green-600'
                      : 'text-gray-600'
                  "
                >
                  {{ item.manualAssignmentMode == 1 ? "Aktif" : "Kapalı" }}
                </span>
                <i
                  class="fas"
                  :class="
                    item.manualAssignmentMode == 1
                      ? 'fa-toggle-on text-green-600'
                      : 'fa-toggle-off text-gray-600'
                  "
                ></i>
                <i class="fas fa-lock ml-1 text-gray-500" title="Bu ayar şu anda değiştirilemiyor"></i>
              </button>
              <button
                v-if="columnKey === 'totalVehicles'"
                @click="showVehicleList(item)"
              >
                <div
                  class="flex items-center justify-center border rounded-lg w-8 h-6"
                  :class="
                    item.rejectStatus > 0
                      ? 'animate-pulse border-red-400 bg-red-400 text-gray-100'
                      : 'border-gray-400'
                  "
                >
                  {{ item.totalVehicles }}
                </div>
              </button>
              <div v-if="columnKey === 'tonnage'">
                {{
                  item.tonnage
                    ? Math.ceil(item.tonnage) +
                      " / " +
                      Math.max(0, item.tonnage - (item.receivedTonnage || 0)).toFixed(2)
                    : "0 / 0"
                }}
              </div>
              <div v-if="columnKey === 'process'">
                <div class="flex items-center space-x-2">
                  <!-- Tahliye tamamlandıysa hiçbir buton gösterme -->
                  <template v-if="shouldShowButtons(item)">
                    <!-- Tamamla Butonu - Sadece manuel mod ve tahliye başlamışsa -->
                    <asyncBtn
                      v-if="item.manualAssignmentMode == 1 && item.stateId == 1 && item.tonnage > (item.receivedTonnage || 0)"
                      @click="completeEvacuation(item)"
                      :loadState="load"
                      text="Tamamla"
                      icon="fas fa-check"
                      size="py-1 "
                      containerClass="bg-blue-600 hover:bg-blue-700 w-32"
                    />

                    <!-- Başlat/Durdur Butonu -->
                    <asyncBtn
                      @click="changeProcess(item)"
                      :loadState="load"
                      :text="item.evacuationState == 2 ? 'Durdur' : 'Başlat'"
                      :disabled="!item.tonnage || item.tonnage === 0"
                      icon=""
                      size="py-1 "
                      :containerClass="
                        !item.tonnage || item.tonnage === 0
                          ? 'bg-gray-400 cursor-not-allowed w-32'
                          : item.evacuationState === 1
                          ? 'bg-green-700 hover:bg-green-600 w-32'
                          : item.evacuationState === 2 && item.receivedTonnage > 0
                          ? 'bg-orange-600 hover:bg-orange-700 w-32'
                          : 'bg-red-700 hover:bg-red-600 w-32'
                      "
                      :title="
                        !item.tonnage || item.tonnage === 0
                          ? 'Toplam tonaj 0 olduğu için tahliye başlatılamaz. Lütfen önce sipariş ekleyin.'
                          : item.evacuationState === 2 && item.receivedTonnage > 0
                          ? `⚠️ DİKKAT: ${item.receivedTonnage.toFixed(2)} TON tonaj zaten yola çıkmış durumda. Dikkatli durdurun!`
                          : ''
                      "
                    />
                  </template>
                  <template v-else>
                    <span class="text-gray-400 text-sm">-</span>
                  </template>
                </div>
              </div>
              <div v-if="columnKey === 'stateId'">
                <div
                  class="w-28 border-r border-opacity-20"
                  :class="getEvacuationStatusClass(item)"
                >
                  <p class="">
                    {{ getEvacuationStatus(item) }}
                  </p>
                </div>
              </div>
              <div v-if="columnKey === 'operations'">
                <div class="flex items-center justify-center">
                  <button
                    style="min-width: 15px;"
                    class="mx-2"
                    :class="item.explanation == '' ? 'opacity-20' : ''"
                    @click="item.explanation == '' ? '' : noteDetailModal(item)"
                  >
                    <img
                      class="w-4 h-4"
                      src="../../../assets/ship/note.svg"
                      alt=""
                    />
                  </button>
                  <button class="mx-2" @click="orderDetail(item)" style="min-width: 15px;">
                    <img
                      class="w-4 h-4"
                      src="../../../assets/ship/diagram.png"
                      alt=""
                    />
                  </button>
                  <button class="mx-2" @click="deleteItem(item)" :disabled="isArchived" :class="isArchived ? 'opacity-30 cursor-not-allowed' : ''">
                    <i class="fas fa-trash text-gray-700"></i>
                  </button>
                </div>
              </div>
            </template>
            <template v-slot:batchOperations>
              <asyncBtn
                v-if="!isArchived"
                icon="fas fa-plus "
                text="Yeni Depo Tahliyesi"
                class="w-36 btn"
                @click="
                  () => (
                    (isNewOrder = 0),
                    (isLaterAddOrder = false),
                    $modal.show('add-plan-modal')
                  )
                "
              />
            </template>
          </LyrausTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Npm
import { LyrausTable } from "lyraus-ui";
import moment from "moment";
// Global Components
import SearchInput from "@/components/general/search-input.vue";
import asyncBtn from "../../../components/general/asyncBtn.vue";
// Local Components
import noteDetail from "@/components/modals/noteDetail/index.vue";
import orderDetail from "./components/orderDetail/index.vue";
import addModal from "./components/add/index.vue";
import updateEvacuationModal from "./components/updateEvacuation.vue";
import vehicleModalVue from "../shipEvacuation/components/vehicle-list/index.vue"; // gemi tahliyesi için oluşturulan vehicle modülü olduğu gibi buraya getirildi 
import notesModal from "../../../components/modals/notesModal/index.vue";
// Networking
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
export default {
  name: "shipEvacuationPlannig-module",
  props: {
    isArchived: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    addModal,
    updateEvacuationModal,
    vehicleModalVue,
    orderDetail,
    asyncBtn,
    noteDetail,
    notesModal,
    SearchInput
  },
  data() {
    return {
      needInterval: true, // app.vue da setInterval için lazım silme
      // isFullScreen: false,
      filterState: false, //Kullanılmıyor ?
      List: [],
      note: "",
      columns: [
        {
          key: "id",
          label: "#",
        },
        {
          key: "name",
          label: "Depo İsmi",
          maxLength: 16,
        },
        {
          key: "startedDate",
          label: "Başlangıç Tarihi",
          isDate: true,
        },
        {
          key: "complatedDate",
          label: "Bitiş Tarihi",
          isDate: true,
        },
        {
          key: "minVehicleCount",
          label: "Min. Araç Sayısı",
        },
        {
          key: "potCount",
          label: "Pot Sayısı",
        },
        {
          key: "manualAssignmentMode",
          label: "Manuel Mod",
          formatter: (val) => (val ? "Açık" : "Kapalı"),
          dontDisplay: true,
        },
        {
          key: "totalVehicles",
          label: "Araçlar",
          dontDisplay: true,
          center: true,
        },
        {
          key: "tonnage",
          label: "Toplam / Kalan",
          dontDisplay: true,
        },
        {
          key: "stateId",
          label: "Durum",
          dontDisplay: true,
          center: true,
        },
        {
          key: "process",
          label: "Tahliye Durumu",
        },
        {
          key: "operations",
          label: "İşlemler",
          dontDisplay: true,
          center: true,
        },
      ],
      load: false,
      search: "",
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      selected: { id: "", plaque: "", vehicleId: "" },
      isNewOrder: "",
      orderList: "",
      //Siparişin Sonradan eklenip eklenmediğine bakıyor true ise sipariş sonradan eklenmiştir
      isLaterAddOrder: false,
    };
  },
  methods: {
    getEvacuationStatus(item) {
      // Tonaj null ise kesinlikle "Sipariş Bekliyor"
      if (item.tonnage === null) {
        return "Sipariş Bekliyor";
      }

      // Tahliye manuel olarak tamamlanmışsa
      if (item.isEvacuationEnd == 1) {
        return "Tamamlandı";
      }

      if (item.evacuationState === 1) {
        return "Tahliye Durduruldu";
      }

      if (item.stateId === 1) {
        const remainingTonnage = Math.max(0, item.tonnage - (item.receivedTonnage || 0));
        return remainingTonnage <= 0 ? "Tamamlandı" : "Başladı";
      }

      if (item.stateId === 2) {
        return "Durduruldu";
      }

      return "Başlamadı";
    },
    getEvacuationStatusClass(item) {
      const status = this.getEvacuationStatus(item);

      // "Tamamlandı" durumu yeşil ve pulse
      if (status === "Tamamlandı") {
        return "text-green-400 animate-pulse duration-200 text-xs font-bold px-3 select-none rounded";
      }

      // "Sipariş Bekliyor" durumu sarı
      if (status === "Sipariş Bekliyor") {
        return "text-yellow-500 text-xs font-bold px-3 select-none rounded";
      }

      // "Tahliye Durduruldu" durumu kırmızı
      if (status === "Tahliye Durduruldu") {
        return "text-red-500 text-xs font-bold px-3 select-none rounded";
      }

      // Diğer tüm durumlar normal stil
      return "text-gray-600 text-opacity-60 text-xs font-bold px-3 select-none rounded";
    },
    shouldShowButtons(item) {
      // Tahliye tamamlanmışsa butonları gösterme
      // Hem numeric 1 hem de string "1" kontrolü
      if (item.isEvacuationEnd == 1 || item.isEvacuationEnd === "1" || item.isEvacuationEnd === true) {
        return false;
      }

      // Kalan tonaj 0 veya negatifse (tüm tonaj teslim edilmişse) tahliye otomatik tamamlanmış sayılır
      // receivedTonnage null/undefined kontrolü (0 değeri geçerlidir!)
      if (item.tonnage && item.receivedTonnage !== null && item.receivedTonnage !== undefined) {
        const remainingTonnage = item.tonnage - item.receivedTonnage;
        if (remainingTonnage <= 0) {
          return false;
        }
      }

      return true;
    },
    async changeProcess(item) {
      this.selected = item;
      if (item.evacuationState === 2) {
        // Manuel modda ve tonaj düşmüşse ekstra uyarı ver
        if (item.manualAssignmentMode == 1 && item.receivedTonnage > 0) {
          const extraWarning = await this.swalBox(
            "warning",
            "⚠️ DİKKAT: ARAÇLAR YOLA ÇIKMIŞ!",
            `Tahliye devam ediyor ve ${item.receivedTonnage.toFixed(2)} TON tonaj zaten yola çıkmış durumda. Kalan tonaj: ${(item.tonnage - item.receivedTonnage).toFixed(2)} TON Yine de durdurmak istediğinize emin misiniz?`,
            true,
            "Evet, Durdur",
            "İptal"
          );

          if (!extraWarning.isConfirmed) {
            return; // Kullanıcı iptal etti
          }
        }

        const result = await this.swalBox(
          "warning",
          "UYARI !",
          "Tahliyeyi durdurmak istediğinize emin misiniz?",
          true,
          "Evet, eminim",
          "Hayır, değilim"
        );

        if (result.isConfirmed) {
          const params = {
            typeId: 1,
            shipId: item.id,
          };
          axios
            .post(bulkShipPlanning.process, params, {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            })
            .then(() => {
              this.addrefresh();
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      } else {
        this.$modal.show("storage-process-modal");
      }
    },
    noteDetailModal(item) {
        this.note = item.explanation;
        this.selected=item;
        this.$modal.show("notes-modal");
    },
    addrefresh() {
      this.getAll();
      this.$refs.orderDetail.showRefresh();
    },
    orderDetail(item) {
      this.selected = item;
      this.$modal.show("orderDetail-modal");
    },
    showVehicleList(item) {
      this.selected = item;
      this.$modal.show("vehicle-list-modal");
      setTimeout(() => {
        this.$refs.orderDetail.getAll();
      }, 100);
    },
    handleSearchValue(val) {
      this.search = val;
    },
    handleSearch() {
      this.clickSearch = false;
      this.searchColumn = "";
      this.currentPage = 0;
      this.getAll();
    },
    handleCurrentPage(val) {
      this.currentPage = val;
    },
    getAll(load = true) {
      if (load) {
        this.List = [];
        this.load = load;
      }
      let url = bulkShipPlanning.getAll +
            "?page=" +
            this.currentPage +
            "&typeId=" +
            2 +
            "&search=" +
            this.search;
      if (this.isArchived) {
        url += "&isArchived=true";
      }
      axios
        .get(
          url,
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(async (res) => {
          this.List = res.data.data.detail;

          // .map((item) => {
          //   return {
          //     ...item,
          //     state: "Kontrol Ediliyor",
          //     stateId: 0,
          //     action: null,
          //   };
          // });
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;

          // await this.getStatusController();
          this.load = false;
        })
        .catch((err) => {
          this.errorBox(err.response);
          this.load = false;
        });
    },
    deleteItem(item) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "Planı silmek istediğinize emin misiniz ?",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          axios
            .post(
              bulkShipPlanning.delete,
              {
                rowId: item.id.toString(),
              },

              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )
            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );

              this.getAll();
            })
            .catch((err) => {
              this.errorBox(err.response);
            });
        }
      });
    },
    toggleManualMode(item) {
      // Bilgilendirme mesajı göster
      this.swalBox(
        "info",
        "Manuel Atama Modu",
        "Manuel Atama Modu aktif olarak ayarlanmış, değiştirilemiyor",
        false,
        this.$t("general.OkayTitle")
      );
    },

    // Tahliyeyi Tamamla - Manuel Mod
    async completeEvacuation(item) {
      const remainingTonnage = Math.max(0, item.tonnage - (item.receivedTonnage || 0)).toFixed(2);
      const result = await this.swalBox(
        "warning",
        "Tahliyeyi Tamamla",
        `${item.name} isimli depoyu tamamlamak istediğine emin misiniz? Kalan tonaj: ${remainingTonnage}`,
        true,
        "Evet, Tamamla",
        "İptal"
      );

      if (result.isConfirmed) {
        this.load = true;
        try {
          await axios.post(
            bulkShipPlanning.completeEvacuation,
            { 
              shipId: item.id,
              orderNo: item.orderNos
            },
            {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            }
          );

          this.swalBox(
            "success",
            "Başarılı",
            "Tahliye başarıyla tamamlandı",
            false,
            this.$t("general.OkayTitle")
          );
          this.getAll();
        } catch (err) {
          this.errorBox(err.response);
        } finally {
          this.load = false;
        }
      }
    },
    // showFilesModal(item) {
    //   this.selected = item;
    //   this.$modal.show("files-modal");
    // },
    // outPointFormatter(name = "", id = 0) {
    //   if (id) {
    //     if (name) return name;
    //     else if (!Number.isInteger(id))
    //       return id.toString().substr(0, 40) + "...";
    //     else return id;
    //   } else return name;
    // },
    async getStatusController() {
      try {
        const result = await axios.get(bulkPlanning.getActionController, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        });
        const list = this.List.map((item) => {
          const findItem = result.data.data?.find((r) => r.id == item.id);
          if (findItem) {
            item.state = findItem.title;
            item.stateId = findItem.type;
            item.action = findItem;
          }
          return item;
        });

        this.List = list;

        return;
      } catch (error) {
        this.swalBox(
          "warning",
          "UYARI!",
          "Durum Kontrol Sistemi başlatılamadı,Lütfen daha sonra tekrar deneyiniz!"
        );
      }
    },
  },
  destroyed() {
    clearInterval(this.$store.state.intervalId);
  },
  created() {
    this.getAll();
  },
  filters: {
    getDateFormat(val) {
      return moment.utc(val).format("LLL");
    },
  },
  watch: {
    currentPage() {
      this.getAll();
    },
    filterState(val) {
      if (!val) this.getAll();
    },
    search(val) {
      if (val.length == 0) this.getAll();
    },
  },
};
</script>

<style></style>
